import { render, staticRenderFns } from "./AvatarUploadDialog.vue?vue&type=template&id=bc8b568a&scoped=true&"
import script from "./AvatarUploadDialog.vue?vue&type=script&lang=js&"
export * from "./AvatarUploadDialog.vue?vue&type=script&lang=js&"
import style0 from "./AvatarUploadDialog.vue?vue&type=style&index=0&id=bc8b568a&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "bc8b568a",
  null
  
)

export default component.exports